export type DashboardLanguage = 'en' | 'km' | 'zh';

export const dashboardLanguages: { code: DashboardLanguage; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'km', label: 'ភាសាខ្មែរ' },
  { code: 'zh', label: '中文' },
];

export const dashboardCopy = {
  en: {
    menu: 'Menu', home: 'Home', more: 'More', back: 'Back to website', notifications: 'Notifications', search: 'Search members, rewards...',
    pages: ['Program overview', 'Members', 'Points ledger', 'Reward catalog', 'Redemptions', 'Sponsors', 'Integrations', 'Program settings'],
    subtitles: ['A real-time snapshot of your loyalty program health', 'Manage members, tiers, and point balances', 'Every earn, redeem, and adjustment event', 'Create and manage what members can redeem', 'Approve, reject, or fulfill redemption requests', 'Sponsor partners, tiers, and placements', 'API keys and connected platforms', 'Earning rules, tiers, and redemption policy'],
    nav: ['Overview', 'Members', 'Points ledger', 'Rewards', 'Redemptions', 'Sponsors', 'Integrations', 'Settings'],
  },
  km: {
    menu: 'ម៉ឺនុយ', home: 'ទំព័រដើម', more: 'បន្ថែម', back: 'ត្រឡប់ទៅគេហទំព័រ', notifications: 'ការជូនដំណឹង', search: 'ស្វែងរកសមាជិក និងរង្វាន់...',
    pages: ['ទិដ្ឋភាពទូទៅ', 'សមាជិក', 'ប្រវត្តិពិន្ទុ', 'បញ្ជីរង្វាន់', 'ការប្តូររង្វាន់', 'អ្នកឧបត្ថម្ភ', 'ការតភ្ជាប់', 'ការកំណត់កម្មវិធី'],
    subtitles: ['ស្ថានភាពកម្មវិធីភាពស្មោះត្រង់របស់អ្នក', 'គ្រប់គ្រងសមាជិក កម្រិត និងសមតុល្យពិន្ទុ', 'ប្រតិបត្តិការទទួល ប្តូរ និងកែប្រែពិន្ទុ', 'បង្កើត និងគ្រប់គ្រងរង្វាន់', 'អនុម័ត បដិសេធ ឬបំពេញសំណើប្តូររង្វាន់', 'ដៃគូ កម្រិត និងទីតាំងផ្សាយពាណិជ្ជកម្ម', 'សោ API និងវេទិកាដែលបានតភ្ជាប់', 'ច្បាប់ទទួលពិន្ទុ កម្រិត និងគោលការណ៍ប្តូររង្វាន់'],
    nav: ['ទិដ្ឋភាពទូទៅ', 'សមាជិក', 'ប្រវត្តិពិន្ទុ', 'រង្វាន់', 'ការប្តូររង្វាន់', 'អ្នកឧបត្ថម្ភ', 'ការតភ្ជាប់', 'ការកំណត់'],
  },
  zh: {
    menu: '菜单', home: '首页', more: '更多', back: '返回网站', notifications: '通知', search: '搜索会员和奖励...',
    pages: ['计划概览', '会员', '积分记录', '奖励目录', '兑换申请', '赞助商', '集成', '计划设置'],
    subtitles: ['实时查看忠诚度计划的运行情况', '管理会员、等级和积分余额', '查看积分获取、兑换和调整记录', '创建和管理可兑换的奖励', '批准、拒绝或完成兑换申请', '赞助合作伙伴、等级和广告位', 'API 密钥和已连接的平台', '积分规则、等级和兑换政策'],
    nav: ['概览', '会员', '积分记录', '奖励', '兑换', '赞助商', '集成', '设置'],
  },
};

export function getDashboardLanguage(value: string): DashboardLanguage {
  return value === 'km' || value === 'zh' ? value : 'en';
}
